import "./styles.contact.css";
import { ToastContainer, toast } from "react-toastify";
import React, { useRef } from "react";
import contact from "../../assets/products/contact.svg";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const contactStyle = {
    background: `url(${contact})`,
    backgroundPosition: "center center",
    objectFit: `cover`,
  };
  const formRef = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result);
          // alert("email sent successfully");
          if (result.status !== 200)
            return toast.error("Error .,Failed to send the Email. Try Again", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          toast.success("Email Sent Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        },
        (error) => {
          toast.error("Error .,Failed to send the Email. Try Again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      );
    formRef.current.reset();
  };

  return (
    <div className="contact-container" id="contact">
      <h1 className="contact-title">Get in Touch With us</h1>
      <div className="contact-wrapper">
        <div className="image-wrapper">
          <div className="contact-image" style={contactStyle}></div>
        </div>
        <div className="contact-form">
          <form ref={formRef} onSubmit={sendEmail}>
            <div className="input-field">
              <input
                className="input-text"
                placeholder="Name"
                name="name"
                required
              />
            </div>

            <div className="input-field">
              <input
                className="input-text"
                placeholder="Email"
                name="email"
                required
              />
            </div>
            <div className="mobile-wrapper">
              <div className="input-code-text">
                <input
                  className="input-text"
                  placeholder="+971"
                  name="country_code"
                  required
                />
              </div>
              <div className="input-number-text">
                <input
                  className="input-text"
                  placeholder="Mobile Number"
                  name="mobile_number"
                  maxLength={10}
                  minLength={10}
                  required
                />
              </div>
            </div>
            <div className="input-field">
              <textarea
                className="input-textbox"
                rows={3}
                placeholder="Enter Message"
                name="message"
                required
              />
            </div>
            <div className="conditions">
              <p>
                By clicking Submit, I authorize Team to Call me about its
                products & helps to join hands to getter . This consent will
                override any registration
              </p>
            </div>
            <div className="input-field">
              <button className="submit-button" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
